/**
 author: william   email:362661044@qq.com
 create_at: 2025/8/12
 **/

import clsx, { type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
